import { render, staticRenderFns } from "./StatusCampanhas.vue?vue&type=template&id=6e4cca16&scoped=true"
import script from "./StatusCampanhas.vue?vue&type=script&lang=js"
export * from "./StatusCampanhas.vue?vue&type=script&lang=js"
import style0 from "./StatusCampanhas.vue?vue&type=style&index=0&id=6e4cca16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4cca16",
  null
  
)

export default component.exports